






import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class Chimp extends Vue {
  @Prop({ default: "primary", type: String }) type!: string;
  @Prop() title!: string;
  mode!: string;

  get typeClass() {
    this.mode = this.type;
    const classes = [`chimp ${this.mode}`];
    return classes;
  }
}
